<template>
    <div>
        <div class="cropper-btn-wrap">
            <div class="cropper-btn-empty" @click="openCropper" v-if="!showImg">
                <div class="btn-default">
                    <i class="el-icon-plus default-icon"></i>
                </div>
            </div>
            <div class="cropper-img-wrap" v-if="showImg">
                <div class="cropper-default-img">
                    <div class="cropper-mask">
                        <i class="el-icon-view cropper-check-img" @click="previewImg"></i>
                    </div>
                    <img :src="showImg"/>
                </div>
                <div class='cropper-single-op'>
                    <el-button size='mini' class="cropper-single-btn" @click="openCropper">重新编辑</el-button>
                </div>
                <i class="el-icon-close cropper-single-close" @click="onCropperRemove"></i>
            </div>
        </div>
        <el-dialog :visible="previewShow" @close="closeDialog" title="查看图片" style="z-index:10;" width="500px" class="overflow-modal">
		<img class="dialog-img" :src="showImg" alt=""/>
		</el-dialog>
        <Cropper v-model='cropperState'
                :keyString="keyString"
                :headers="headers"
                :name="name"
                :action="action"
                :cropperImg="showImg"
                :outputSize="size"
                :outputType="outputType"
                :full="full"
                :canMove="canMove"
                :canMoveBox="canMoveBox"
                :original="original"
                :autoCrop="autoCrop"
                :autoCropWidth="Number(autoCropWidth)"
                :autoCropHeight="Number(autoCropHeight)"
                :fixedBox="fixedBox"
                :onProgress="onProgress"
                :onSuccess="onSuccess"
                :onError="onError"
                @closeDialog="closeCropper"
            ></Cropper>
    </div>
</template>

<script type="text/babel">
import Cropper from './cropper';
import { domainApi } from '@/utils/domain';
export default {
        components: {
            Cropper
        },
        props: {
            keyString:{
                type:String,
                default:''
            },
            headers: {
                type: Object,
                default() {
                    return {};
                }
            },            
            action: {
                type: String,
                // required: true
            },
            name: {
                type: String,
                default: 'file'
            },
            img: {
                type: String,
                default:''
            },
            size: {
                type: Number,
                default: 1
            },
            full: {
                type: Boolean,
                default: false
            },
            //输出原图比例截图 props名full
            outputType: {
                type: String,
                default: 'png'
            },
            canMove: {
                type: Boolean,
                default: true
            },

            original: {
                type: Boolean,
                default: false
            },
            canMoveBox: {
                type: Boolean,
                default: true
            },
            autoCrop: {
                type: Boolean,
                default: true
            },
            autoCropWidth: {
                type: [String,Number],
                default: 200,
            },
            autoCropHeight:  {
                type: [String,Number],
                default: 200,
            },
            fixedBox: {
                type: Boolean,
                default: true
            },
            onProgress: Function,
            onSuccess: Function,
            onError: Function,
            onRemove: Function
        },
        data() {
            return {
                cropperState: false,
                previewShow: false,
                showImg: this.img == ''?this.img:domainApi.pic_domain + this.img
            };
        },
        watch:{
            img(){
                this.showImg = domainApi.pic_domain + this.img
                if(this.img == ''){
                    this.showImg = this.img
                }else{
                    this.showImg = domainApi.pic_domain + this.img
                }
            }
        },
        computed: {
        },
        methods: {
            openCropper(){
                this.cropperState = true;
            },

            closeCropper() {
                this.cropperState = false;
            },
            previewImg() {
                
                this.previewShow = true;
            },

            closeDialog() {
                this.previewShow = false;
            },

            onCropperRemove(){
                this.showImg = '';
                this.onRemove('',this.keyString)
            }
        },
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    @import './index.scss';
</style>